export default (api) => {
    return {
        index: options => api.get(`streams`, options),
        get: (stream_code, options) => api.get(`streams/${stream_code}`, options),
        update: (stream_id, data, options) => api.put(`streams/${stream_id}`, data, options),
        destroy: (stream_id, options) => api.delete(`streams/${stream_id}`, options),
        userStats: (school_id, user_id) => api.get(`streams/schools/${school_id}/users/${user_id}/stats`),
        status: {
            update: (stream_id, data, options) => api.put(`streams/${stream_id}/status`, data, options)
        },
        content: {
            index: (stream_id, options) => api.get(`streams/${stream_id}/content`, options)
        },
        act: (stream_id, data, options) => api.post(`streams/${stream_id}/action`, data, options)
    }
}
